import standingsActions from "../reducers/standingsReducer/standingsActions";
import standingsService from "../reducers/standingsReducer/standingsService";
import { setLoading } from "../reducers/loadingReducer";
import handler from "../../utils/functions/handler";

export const loadPositions =
  (organizerId, tournamentId) => async (dispatch) => {
    dispatch(setLoading.true("standings.loadPositions"));
    const [error, positions] = await standingsService.loadPositions(
      organizerId,
      tournamentId
    );
    dispatch(setLoading.false("standings.loadPositions"));

    if (error) {
      return dispatch(
        handler({
          ...error,
          handler: {},
        })
      );
    }
    dispatch(standingsActions.setAllStandings(positions));
  };
